var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Modalidad de pago*")])]),_c('b-col',[_c('b-form-select',{attrs:{"options":_vm.comboFormasPago,"disabled":_vm.disabled},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }